import type { ActivityCard, Economy, SpoylUser, Transaction } from '../types';

/**
 * Placeholder data for the skeleton. Every export here is meant to be deleted
 * once the matching backend endpoint exists — keep it in this single file so
 * the swap is mechanical.
 */

export const DEMO_USER: SpoylUser = {
  id: '0',
  username: 'preview',
  displayName: 'Guest',
  avatar: null,
};

export const DEMO_ECONOMY: Economy = {
  credits: 1250,
  level: 7,
  xp: 340,
  xpToNextLevel: 500,
};

export const ACTIVITIES: ActivityCard[] = [
  {
    id: 'wheel',
    name: 'The Wheel',
    tagline: 'One free spin a day, real rewards on the line.',
    status: 'soon',
    accent: 'brand',
    icon: 'wheel',
  },
  {
    id: 'scratch',
    name: 'Scratch cards',
    tagline: 'Scratch, reveal, cash in.',
    status: 'locked',
    accent: 'gold',
    icon: 'ticket',
  },
  {
    id: 'gacha',
    name: 'Gacha',
    tagline: 'Summon rare rewards.',
    status: 'locked',
    accent: 'rose',
    icon: 'sparkles',
  },
  {
    id: 'tcg',
    name: 'TCG',
    tagline: 'Collect and trade your cards.',
    status: 'locked',
    accent: 'cyan',
    icon: 'cards',
  },
];

export const RECENT_TRANSACTIONS: Transaction[] = [
  {
    id: 't1',
    label: 'Daily reward',
    kind: 'earn',
    amount: 150,
    at: new Date(Date.now() - 2 * 3600_000).toISOString(),
  },
  {
    id: 't2',
    label: 'Wheel spin',
    kind: 'spend',
    amount: 50,
    at: new Date(Date.now() - 5 * 3600_000).toISOString(),
  },
  {
    id: 't3',
    label: 'Voice activity bonus',
    kind: 'earn',
    amount: 75,
    at: new Date(Date.now() - 26 * 3600_000).toISOString(),
  },
];

export interface BadgeEntry {
  id: string;
  label: string;
  description: string;
  unlocked: boolean;
}

export const BADGES: BadgeEntry[] = [
  {
    id: 'founder',
    label: 'Founding member',
    description: 'Here since the early days of the server.',
    unlocked: true,
  },
  {
    id: 'first-spin',
    label: 'First spin',
    description: 'Spin the wheel for the first time.',
    unlocked: false,
  },
  {
    id: 'high-roller',
    label: 'High roller',
    description: 'Wager 10,000 credits in total.',
    unlocked: false,
  },
  {
    id: 'collector',
    label: 'Collector',
    description: 'Pull your first legendary card.',
    unlocked: false,
  },
];
